import React from 'react';
import PropTypes from 'prop-types';
import {AppProvider, TopBar, Link} from '@shopify/polaris';
import { fullName } from '../../utils';
import axiosRails from '@utils/axios';
import translations from '@shopify/polaris/locales/es.json';

const propTypes = {
  user: PropTypes.object.isRequired,
  users_all_path: PropTypes.string.isRequired,

  changeLocaleURL: PropTypes.string.isRequired,
  currentLocale: PropTypes.string,
  userPaths: PropTypes.array.isRequired,
};

const theme = {
  colors: {
    topBar: {
      background: '#fff',
    },
  },
  logo: {
    width: 124,
    topBarSource: imagePaths.logo,
    url: '/',
    accessibilityLabel: 'Barulu Seller',
  },
};

class NavigationWrapper extends React.Component {
  constructor(props){
    super(props)

    const fullname = fullName(this.props.user);

    this.state = {
      userMenuOpen: false,
      userFullName: fullname
    };
  }

  render() {
    return (
      <AppProvider theme={theme} i18n={translations}>
        <div id="TopBarContainer">
          <TopBar
            showNavigationToggle={false}
            userMenu={this.userMenuMarkup()}
          />
        </div>
      </AppProvider>
    );
  }

  toggleUserMenu = () => {
    this.setState(({ userMenuOpen }) => ({ userMenuOpen: !userMenuOpen }));
  };

  logOut=()=>{
    axiosRails.delete("/users/sign_out").then(res=>{
      // console.log(res.data)
      location.reload();
    })
  }

  changeLocale = async () => {
    let response = await axiosRails.put(this.props.changeLocaleURL, {
      locale: this.props.currentLocale == "es" ? "en" :  "es"
    });
    window.location = response.data.redirectURL;
  }

  userMenuMarkup = () => {
    return(
      <TopBar.UserMenu
        actions={[
          {
            items: this.props.userPaths
          },
          // {
            // items: [{
              // content: I18n.t("actions.change_locale"), onAction: this.changeLocale
            // }]
          // },
          // -------- Special actions --------
          {
            items: [{content: 'Log Out', onAction: this.logOut}]
          },
        ]}
        name={this.state.userFullName}
        initials={this.state.userFullName.charAt(0)}
        open={this.state.userMenuOpen}
        onToggle={this.toggleUserMenu}
      />
    )
  }

}

NavigationWrapper.propTypes = propTypes;
export default NavigationWrapper;